import React, { Component, Fragment } from 'react';
import Input from 'Components/Input';
import ResponsiveTable from 'Components/ResponsiveTable';
import { Courier_data, ZONE_LIST } from 'Constants/commonConstants';
import Dropdown from './../Dropdown/index';
import CourierTrip from 'Models/CourierTrip';
import { ReactComponent as TrashIcon } from 'Icons/trash.svg';
import Cx from 'classnames';

const otherCharges = {
    name: "Common Charges",
    movement_type: "",
    movement_name: "",
    mode_type: "",
    mode_name: "",
    description: "",
    other_charge_cost: ""
}

const aZones = {
    zone_name: "",
    movement_type: "",
    movement_name: "",
    mode_type: "",
    mode_name: "",
    slabs: {
        from: '',
        to: ''
    },
    zone_list: {
        zone_to: '',
        qbr: null,
        max_tat: null
    }
}

class CourierTripTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            courierTrips: JSON.parse(JSON.stringify(props.courierTrips))|| [],
            courierOtherCharges: props.courierOtherCharges && props.courierOtherCharges.length && [ ...props.courierOtherCharges ] || [{...otherCharges}],
            rowZones: props.rowZones || [],
            colZones: props.colZones || [],
            additionalZones: props.additionalZones && props.additionalZones.length && JSON.parse(JSON.stringify(props.additionalZones)) || [JSON.parse(JSON.stringify(aZones))]
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if(!this.state.courierTrips.length) {
            this.setState({
                courierTrips: JSON.parse(JSON.stringify(nextProps.courierTrips)),
                rowZones: nextProps.rowZones,
                colZones: nextProps.colZones
            })
        } 
        else if(nextProps.courierTrips.length !== this.props.courierTrips.length) {
            this.setState({
                courierTrips: JSON.parse(JSON.stringify(nextProps.courierTrips)),
                rowZones: nextProps.rowZones,
                colZones: nextProps.colZones
            })
        } else if(JSON.stringify(nextProps.courierTrips) !== JSON.stringify(this.props.courierTrips)) {
            this.setState({
                courierTrips: JSON.parse(JSON.stringify(nextProps.courierTrips)),
                rowZones: nextProps.rowZones,
                colZones: nextProps.colZones
            })
        }
        if(JSON.stringify(nextProps.courierOtherCharges) !== JSON.stringify(this.props.courierOtherCharges)) {
            this.setState({
                courierOtherCharges: nextProps.courierOtherCharges && nextProps.courierOtherCharges.length && [ ...nextProps.courierOtherCharges ] || [{...otherCharges}],
                rowZones: nextProps.rowZones,
                colZones: nextProps.colZones
            })
        }
        if(JSON.stringify(nextProps.additionalZones) !== JSON.stringify(this.props.additionalZones)) {
            this.setState({
                additionalZones: nextProps.additionalZones && nextProps.additionalZones.length && JSON.parse(JSON.stringify(nextProps.additionalZones)) || [JSON.parse(JSON.stringify(aZones))],
                rowZones: nextProps.rowZones,
                colZones: nextProps.colZones
            })
        }
    } 

    onChange = (e, index , zone) => {
        const { courierTrips } = this.state;
        const { value, name } = e.target;
        const zIndex = (courierTrips[index].zone_list || []).findIndex(zlist => zlist.zone_to === zone);
        if(zIndex >= 0) {
            courierTrips[index].zone_list[zIndex][name] = value ? Number(value) : value;
        } else {
            courierTrips[index].zone_list.push({
                [name]: value ? Number(value) : value,
                ['zone_to']: zone
            })
        }
        this.setState({ courierTrips }, () => {
            this.props.addCourierTrip(this.state.courierTrips, 1);
        });
    }

    onAddZones = (name, index) => {
        const { courierTrips } = this.state;
        const { courierZones } = this.props;
        const newZoneObj = new CourierTrip('', courierZones, name);
        newZoneObj.movement_type = courierTrips[index].movement_type
        newZoneObj.movement_name = courierTrips[index].movement_name;
        newZoneObj.mode_type = courierTrips[index].mode_type;
        newZoneObj.mode_name = courierTrips[index].mode_name;
        courierTrips.splice(index + 1, 0, newZoneObj);
        this.setState({
            courierTrips
        }, () => {
            this.props.addCourierTrip(this.state.courierTrips, 1);
        })
    }

    onDeleteZone = (index) => {
        const { courierTrips } = this.state;
        courierTrips.splice(index, 1);
        this.setState({
            courierTrips
        }, () => {
            this.props.addCourierTrip(this.state.courierTrips, 1);
        })
    }

    onSelect = (selItem, index, id, name) => {
        const { courierTrips } = this.state;
        courierTrips[index][id] = selItem.value;
        courierTrips[index][name] = selItem.name;
        this.setState({
            courierTrips
        }, () => {
            this.props.addCourierTrip(this.state.courierTrips, 1);
        })
    }

    onChangeSlab = (e, index) => {
        const { courierTrips } = this.state;
        const { name, value } = e.target;
        courierTrips[index].slabs[name] = value;
        this.setState({
            courierTrips
        }, () => {
            this.props.addCourierTrip(this.state.courierTrips, 1);
        })
    }

    onAddOC = () => {
        const { courierOtherCharges } = this.state;
        courierOtherCharges.push({ ...otherCharges });
        this.setState({ courierOtherCharges },() => {
            this.props.addCourierTrip(this.state.courierOtherCharges, 2);
        });
    }

    onDeleteOC = (index) => {
        const { courierOtherCharges } = this.state;
        courierOtherCharges.splice(index, 1);
        this.setState({ courierOtherCharges },() => {
            this.props.addCourierTrip(this.state.courierOtherCharges, 2);
        });
    }

    onChangeOC = (e, index) => {
        const { courierOtherCharges } = this.state;
        const { value, name } = e.target;
        courierOtherCharges[index][name] = name === 'other_charge_cost' ? +value : value;
        this.setState({  courierOtherCharges }, () => {
            this.props.addCourierTrip(this.state.courierOtherCharges, 2);
        });
    }

    onSelectOC = (selItem, index, id, name) => {
        const { courierOtherCharges } = this.state;
        courierOtherCharges[index][id] = selItem.value;
        courierOtherCharges[index][name] = selItem.name;
        this.setState({  courierOtherCharges }, () => {
            this.props.addCourierTrip(this.state.courierOtherCharges, 2);
        });
    }

    onSelectColumnZone = (value, columInd, zoneColumnList) => {
        const { courierTrips, colZones } = this.state;
        const isColumnHeader = (zoneColumnList || []).find(colHeader => colHeader.zone_to === value.zone_to);
        if(isColumnHeader && isColumnHeader.zone_to) {
            return alert('Column Header Already Exist');
        } else {
            (courierTrips || []).map(zone => (
                zone.zone_list[columInd].zone_to = value.zone_to
            ))
            if(!colZones.find(zone => zone.zone_to.toLowerCase() === value.zone_to.toLowerCase())) {
                colZones.push({
                    zone_to: value.zone_to
                })
            }
        }
        this.setState({ courierTrips, colZones },  () => {
            this.props.addCourierTrip(this.state.courierTrips, 1);
        });
    }

    onDeleteColumn = (colIndex) => {
        const { courierTrips } = this.state;
        (courierTrips || []).map(zone => (
            zone.zone_list.splice(colIndex, 1)
        ));
        this.setState({ courierTrips },  () => {
            this.props.addCourierTrip(this.state.courierTrips, 1);
        });
    }

    onAddColumnZones = () => {
        const { courierTrips } = this.state;
        const zoneObj = {
            zone_to: '',
            qbr: '',
            max_tat: ''
        };
        (courierTrips || []).forEach(zone => {
            zone.zone_list.push({...zoneObj});
        });
        this.setState({ courierTrips },  () => {
            this.props.addCourierTrip(this.state.courierTrips, 1);
        });
    }

    onAddAZ = () => {
        const { additionalZones } = this.state;
        const objAZone = JSON.parse(JSON.stringify(aZones));
        console.log(objAZone);
        additionalZones.push({ ...objAZone });
        this.setState({ additionalZones },() => {
            this.props.addCourierTrip(this.state.additionalZones, 3);
        });
    }

    onDeleteAZ = (index) => {
        const { additionalZones } = this.state;
        additionalZones.splice(index, 1);
        this.setState({ additionalZones },() => {
            this.props.addCourierTrip(this.state.additionalZones, 3);
        });
    }

    onChangeAZ = (e, index, isSlab) => {
        const { additionalZones } = this.state;
        const { value, name } = e.target;
        if(isSlab) {
            additionalZones[index]['slabs'][name] = value && Number(value) || '';
        } else if(name === 'zone_name'){
            additionalZones[index][name] = value;
        } else {
            additionalZones[index]['zone_list'][name] = (name === 'zone_to') && value || (value && Number(value)) || '';
        }
        this.setState({  additionalZones }, () => {
            this.props.addCourierTrip(this.state.additionalZones, 3);
        });
    }

    onSelectAZ = (selItem, index, id, name) => {
        const { additionalZones } = this.state;
        additionalZones[index][id] = selItem.value;
        additionalZones[index][name] = selItem.name;
        this.setState({  additionalZones }, () => {
            this.props.addCourierTrip(this.state.additionalZones, 3);
        });
    }

    render() {
        const { 
                courierMovements, 
                courierModes, 
                courierZones,
                courierSlabs,
                rfqBiddingDetails
            } = this.props;

        const {
            courierTrips,
            courierOtherCharges,
            rowZones,
            additionalZones,
            colZones
        } = this.state;

        const zoneColumnList = courierTrips && courierTrips.length > 0 && courierTrips[0].zone_list || [];
        return(
            <Fragment>
            <ResponsiveTable className="courier-table pv-10 ph-10 ">
                {/* <div className="courier-table pv-10 ph-10 z-100"> */}
                    <table cellpadding="0" cellspacing="0" className="col-1">
                        <thead>
                           <tr>
                              <th rowspan="2" className="first">Zone</th>
										<th rowspan="2" className="first-col addtrip_second" >Movement Type </th>
										<th rowspan="2" className="addtrip_third">Mode Type</th>
										<th rowspan="2" className="addtrip_fourth">{'Slab'}{rfqBiddingDetails && rfqBiddingDetails.pricingBasisName && ` (${rfqBiddingDetails.pricingBasisName})`}</th>

                                {zoneColumnList.map((list, lIndex) => {
                                    return(
                                        <Fragment>
                                            <th colspan="2"> 
                                             {/* {list.zone_to} */}
                                             <Dropdown
                                                    onSelect = {(value) => this.onSelectColumnZone(value, lIndex, zoneColumnList)}
                                                    selectedItem = {list.zone_to && (colZones || []).find(zone =>zone.zone_to === list.zone_to ) || null}
                                                    items={colZones}
                                                    label="Select Zone"
                                                    displayKey="zone_to"
                                                    className="inBlock wt-100 courier-header-zone"
                                                    isInput={true}
                                                />
                                            <span className="white-color fs-24 fBold ml-5 curP" onClick={this.onAddColumnZones}>+</span> 
                                            {zoneColumnList.length > 1 && <TrashIcon 
                                                width="15" 
                                                height="15" 
                                                className="error-color fs-24 fBold ml-5 curP courier-header-delete"
                                                fill="white"
                                                onClick={() => this.onDeleteColumn(lIndex)}
                                            />}
                                            </th>
                                        </Fragment>
                                    )
                                })}
                            </tr>
                            {/* <tr> */}
                                {(zoneColumnList || []).map((list, lIndex) => {
                                return (
                                    // <td>
                                    //     <tr>
                                        <Fragment>
                                            <th>QBR</th>
                                            <th>Max TAT</th>
                                        </Fragment>
                                        // </tr>
                                    // </td> 
                                    )
                                })}
                            {/* </tr> */}
                        </thead>
                        <tbody>
                            {
                                (courierTrips || []).map((courier, courierIndex) => {
                                    return(
											<tr className="firt-row">
												<td style={{ 'borderBottom': '1px solid grey', zIndex: `${500-courierIndex}`}} className={'dropdown_td first'}>
                                                {/* {courier.zone_name} */}
                                                <Dropdown
                                                    onSelect = {(value) => {
                                                        const { courierTrips, rowZones } = this.state;
                                                        if(!(rowZones || []).map(zone => zone.name).includes(value.name)){
                                                            rowZones.push(value);
                                                        } 
                                                        courierTrips[courierIndex].zone_name = value.name;
                                                        this.setState({
                                                            courierTrips,
                                                            rowZones
                                                        })
                                                    }}
                                                    selectedItem = {courier.zone_name && (rowZones || []).find(zone => zone.name === courier.zone_name) || null}
                                                    items={rowZones}
                                                    label="Select Zone"
                                                    displayKey="name"
                                                    className="inBlock wt-100"
                                                    isInput={true}
                                                />
                                                <div className={Cx("wt-50 fRight inBlock", {
                                                    'mt-10': courierTrips.length === 1
                                                })}>
                                                {(!courierTrips[courierIndex+1] || (courier.zone_name !== courierTrips[courierIndex+1].zone_name)) &&
                                                 <span className="theme-color fs-24 fBold ml-5 curP" onClick={() =>this.onAddZones(courier.zone_name, courierIndex)}>+</span> 
                                                }
                                                {courierTrips.length > 1 && <TrashIcon 
                                                    width="15" 
                                                    height="15" 
                                                    className="error-color fs-24 fBold ml-5 curP mt-10"
                                                    onClick={() => this.onDeleteZone(courierIndex)}
                                                />}
                                                </div>
                                            </td>
											<td style={{ 'borderBottom': '1px solid grey', zIndex: `${500 - courierIndex}`}} className={'dropdown_td addtrip_second'}>
                                                <Dropdown
                                                    onSelect = {(value) => this.onSelect(value, courierIndex, 'movement_type', 'movement_name')}
                                                    selectedItem = {courier.movement_type && (courierMovements || []).find(movmentType => movmentType.value === courier.movement_type) || null}
                                                    items={courierMovements}
                                                    label="Select Movement"
                                                    displayKey="name"
													className="inBlock wt-168 z-2"
                                                />
                                            </td>
											<td style={{ 'borderBottom': '1px solid grey', zIndex: `${500 - courierIndex}`}} className={'dropdown_td addtrip_third'}>
                                                <Dropdown
                                                    onSelect = {(value) => this.onSelect(value, courierIndex, 'mode_type', 'mode_name')}
                                                    items={courierModes}
                                                    selectedItem = {courier.mode_type && (courierModes || []).find(mode => mode.value === courier.mode_type) || null}
                                                    label="Select Mode"
                                                    displayKey="name"
													className="inBlock wt-133"
                                                />
                                            </td>
                                            <td style={{ 'borderBottom': '1px solid grey' }} className="slab addtrip_fourth">
                                                {/* <Dropdown
                                                    onSelect = {(value) => this.onSelectSlab(value, courierIndex)}
                                                    items={courierSlabs}
                                                    selectedItem={courier.slabs}
                                                    label="Select Slab"
                                                    displayKey="slab"
                                                    className={'wt-150'}
                                                /> */}
                                                <Input 
                                                    type="number"
                                                    value={courier.slabs.from} 
                                                    name="from" 
                                                    placeHolder="From"
                                                    onChange={(e) => this.onChangeSlab(e, courierIndex)}
                                                    className={'wt-50 mr-5 inBlock'}
                                                />
                                                <div className="mt-10 inBlock">{'-'}</div>
                                                <Input 
                                                    type="number"
                                                    value={courier.slabs.to} 
                                                    name="to" 
                                                    placeHolder="To"
                                                    className={'wt-50 inBlock'}
                                                    onChange={(e) => this.onChangeSlab(e, courierIndex)}
                                                />
                                            </td>
                                            {
                                                (zoneColumnList || []).map(zone => {
                                                    const zoneData = courier.zone_list.find(zlist => zlist.zone_to === zone.zone_to) || {
                                                        zone_to: zone.zone_to,
                                                        qbr: '',
                                                        max_tat: ''
                                                    };
                                                    return (
                                                        // <td style={{ "borderBottom": "1px solid grey"}}>
                                                        //     <tr>
                                                            <Fragment>
                                                                <td style={{ "borderBottom": "1px solid grey"}}>
                                                                    <Input 
                                                                        type="number"
                                                                        value={zoneData.qbr || ''} 
                                                                        name="qbr" 
                                                                        placeHolder="QBR"
                                                                        className="wt-70"
                                                                        onChange={(e) => this.onChange(e, courierIndex, zone.zone_to)}
                                                                    />
                                                                </td>
                                                                <td style={{ "borderBottom": "1px solid grey"}}>
                                                                    <Input 
                                                                        type="number"
                                                                        value={zoneData.max_tat || ''}
                                                                        placeHolder="Max TAT" 
                                                                        name="max_tat" 
                                                                        className="wt-70"
                                                                        onChange={(e) => this.onChange(e, courierIndex, zone.zone_to)}
                                                                    />
                                                                </td>
                                                            </Fragment>
                                                            // </tr> 
                                                        // </td> 
                                                    )
                                                })
                                            }
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                {/* </div> */}
            </ResponsiveTable>

            <div className="courier-table">
                    <table className='col-1 mt-20' cellpadding="0" cellspacing="0">
                        <thead>
                            <tr>
                                <th>From</th>
                                <th>To</th>
                                <th>Movement Type</th>
                                <th>Mode Type</th>
                                <th>Slab (Rate/Box)</th>
                                <th>QBR</th>
                                <th>Max TAT</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(additionalZones || []).map((additinalZone, aIndex) => {
                                return(
                                    <tr>
                                        <td style={{ 'borderBottom': '1px solid grey'}}>
                                            <Input 
                                                value={additinalZone.zone_name || ''} 
                                                name="zone_name" 
                                                placeHolder="From"
                                                onChange={(e) => this.onChangeAZ(e, aIndex)}
                                                className="tCenter"
                                            />
                                        </td>
                                        <td style={{ 'borderBottom': '1px solid grey'}}>
                                            <Input 
                                                value={additinalZone.zone_list && additinalZone.zone_list.zone_to || ''} 
                                                name="zone_to" 
                                                placeHolder="To"
                                                onChange={(e) => this.onChangeAZ(e, aIndex)}
                                                className="tCenter"
                                            />
                                        </td>
                                        <td style={{ 'borderBottom': '1px solid grey'}}>
                                            <Dropdown
                                                onSelect = {(value) => this.onSelectAZ(value, aIndex, 'movement_type', 'movement_name')}
                                                selectedItem = {additinalZone.movement_type && (courierMovements || []).find(movmentType => movmentType.value === additinalZone.movement_type) || null}
                                                items={courierMovements}
                                                label="Select Movement"
                                                displayKey="name"
                                                isZIndexMore={true}
                                            />
                                        </td>
                                        <td style={{ 'borderBottom': '1px solid grey'}}>
                                            <Dropdown
                                                onSelect = {(value) => this.onSelectAZ(value, aIndex, 'mode_type', 'mode_name')}
                                                items={courierModes}
                                                selectedItem = {additinalZone.mode_type && (courierModes || []).find(mode => mode.value === additinalZone.mode_type) || null}
                                                label="Select Mode"
                                                displayKey="name"
                                            />
                                        </td>
                                        <td style={{ 'borderBottom': '1px solid grey' }} className="slab">
                                            <Input 
                                                value={additinalZone.slabs && additinalZone.slabs.from || ''} 
                                                name="from" 
                                                placeHolder="From"
                                                onChange={(e) => this.onChangeAZ(e, aIndex, true)}
                                                className={'wt-50 mr-5 inBlock'}
                                            />
                                            <div className="mt-10 inBlock">{'-'}</div>
                                            <Input 
                                                value={additinalZone.slabs && additinalZone.slabs.to || ''} 
                                                name="to" 
                                                placeHolder="To"
                                                onChange={(e) => this.onChangeAZ(e, aIndex, true)}
                                                className={'wt-50 mr-5 inBlock'}
                                            />
                                        </td>
                                        <td style={{ 'borderBottom': '1px solid grey'}}>
                                            <Input 
                                                value={additinalZone.zone_list && additinalZone.zone_list.qbr || ''} 
                                                name="qbr" 
                                                placeHolder="QBR"
                                                onChange={(e) => this.onChangeAZ(e, aIndex)}
                                                className="tCenter"
                                            />
                                        </td>
                                        <td style={{ 'borderBottom': '1px solid grey'}}>
                                            <Input 
                                                value={additinalZone.zone_list && additinalZone.zone_list.max_tat || ''} 
                                                name="max_tat" 
                                                placeHolder="Max TAT"
                                                onChange={(e) => this.onChangeAZ(e, aIndex)}
                                                className="tCenter"
                                            />
                                        </td>
                                        <td style={{ 'borderBottom': '1px solid grey', 'borderRight': '1px solid grey'} }>
                                                {(aIndex === (additionalZones.length -1)) &&
                                                 <span className="theme-color fs-24 fBold ml-5 curP" onClick={this.onAddAZ}>+</span> 
                                                }
                                                {(additionalZones.length !== 1) && <TrashIcon 
                                                    width="15" 
                                                    height="15" 
                                                    className="error-color fs-24 fBold ml-5 curP mt-10"
                                                    onClick={() => this.onDeleteAZ(aIndex)}
                                                />}
                                        </td>
                                    </tr>
                                )})
                            }
                        </tbody>
                    </table>
                </div>

            {/* <ResponsiveTable className="mt-20 mb-50"> */}
                <div className="courier-table">
                    <table className='col-1 mt-20' cellpadding="0" cellspacing="0">
                        <thead>
                            <tr>
                                <th colspan="5">Common Charges</th>
                            </tr>
                            <tr>
                                <th>Description</th>
                                <th>Movement Type</th>
                                <th>Mode Type</th>
                                <th>QBR</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(courierOtherCharges || []).map((oCharge, oChargeIdx) => {
                                return(
                                    <tr>
                                        <td style={{ 'borderBottom': '1px solid grey'}}>
                                            <Input 
                                                value={oCharge.description || ''} 
                                                name="description" 
                                                placeHolder="Description"
                                                onChange={(e) => this.onChangeOC(e, oChargeIdx)}
                                                className="tCenter"
                                            />
                                        </td>
                                        <td style={{ 'borderBottom': '1px solid grey'}}>
                                            <Dropdown
                                                onSelect = {(value) => this.onSelectOC(value, oChargeIdx, 'movement_type', 'movement_name')}
                                                selectedItem = {oCharge.movement_type && (courierMovements || []).find(movmentType => movmentType.value === oCharge.movement_type) || null}
                                                items={courierMovements}
                                                label="Select Movement"
                                                displayKey="name"
                                                isZIndexMore={true}
                                            />
                                        </td>
                                        <td style={{ 'borderBottom': '1px solid grey'}}>
                                            <Dropdown
                                                onSelect = {(value) => this.onSelectOC(value, oChargeIdx, 'mode_type', 'mode_name')}
                                                items={courierModes}
                                                selectedItem = {oCharge.mode_type && (courierModes || []).find(mode => mode.value === oCharge.mode_type) || null}
                                                label="Select Mode"
                                                displayKey="name"
                                                isZIndexMore={true}
                                            />
                                        </td>
                                        <td style={{ 'borderBottom': '1px solid grey'}}>
                                            <Input 
                                                value={oCharge.other_charge_cost || ''} 
                                                name="other_charge_cost" 
                                                placeHolder="QBR"
                                                onChange={(e) => this.onChangeOC(e, oChargeIdx)}
                                                className="tCenter"
                                            />
                                        </td>
                                        <td style={{ 'borderBottom': '1px solid grey', 'borderRight': '1px solid grey'} }>
                                                {(oChargeIdx === (courierOtherCharges.length -1)) &&
                                                 <span className="theme-color fs-24 fBold ml-5 curP" onClick={this.onAddOC}>+</span> 
                                                }
                                                {(courierOtherCharges.length !== 1) && <TrashIcon 
                                                    width="15" 
                                                    height="15" 
                                                    className="error-color fs-24 fBold ml-5 curP mt-10"
                                                    onClick={() => this.onDeleteOC(oChargeIdx)}
                                                />}
                                        </td>
                                    </tr>
                                )})
                            }
                        </tbody>
                    </table>
                </div>
            {/* </ResponsiveTable> */}
            </Fragment>
        )
    }
}

export default CourierTripTable;